export enum WebhookEventsTableFiltersActionType {
  SetSearchInputValue = 'webhookEventsTableFilters/setSearchInputValue',
  ChangeFilters = 'webhookEventsTableFilters/changeFilters',
  ClearFilters = 'webhookEventsTableFilters/clearFilters',
}
